import { render, staticRenderFns } from "./SepaIcon.vue?vue&type=template&id=a3673f72&"
import script from "./SepaIcon.vue?vue&type=script&lang=js&"
export * from "./SepaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports